import { trackGoal } from "../../../../shared/js/metrika";

$(document).ready(function () {
  let e = $(".tpl__js-open-popup-form-uniq-cooperation-btn"),
    t = $(".tpl__js-popup-form-uniq-cooperation"),
    o = $(".tpl__js-open-popup-form-uniq-unsubscribe-btn"),
    p = $(".tpl__js-popup-form-uniq-unsubscribe"),
    n = $("html"),
    r = "tpl__is-fixed";
  function s(e) {
    return (
      n.addClass(r),
      e
        .on("click.popup", ".tpl-popup-form-uniq__overflow", function (t) {
          t.stopPropagation();
          let o = e.find(".tpl-popup-form-uniq__body");
          o.is(t.target) || 0 !== o.has(t.target).length || a(e);
        })
        .on("click.popup", ".tpl__js-close-popup-form-uniq-btn", function (t) {
          t.preventDefault(), a(e);
        })
        .on("focus.popup", ".tpl__js-form-popup-required", function () {
          let e = $(this).closest(".tpl-form-popup-label");
          e.hasClass("tpl__is-error") && e.removeClass("tpl__is-error");
        })
        .on("submit.popup", "form", function (t) {
          t.preventDefault();
          let o = $(this),
            p = o.find(".tpl-popup-form-uniq__btn-submit"),
            n = !0,
            r = {},
            s = {};
          if (
            (u(o),
            o.find("[name]").each(function () {
              var e;
              let t = $(this),
                o = t.attr("name"),
                p = t.val();
              "smart-token" === o && (o = "captcha"),
                ("captcha" === o ||
                  t.hasClass("tpl__js-form-popup-required")) &&
                ((e = t),
                e.is(":checkbox") ? !e.is(":checked") : "" === e.val())
                  ? (l(t, "Поле обязательно к заполнению"), (n = !1))
                  : ((r[o] = p), (s[o] = t)),
                "answer" === o &&
                  null == document.querySelector('[type="radio"]:checked') &&
                  (document.getElementById(
                    "error-answer-popup-unsubscribe"
                  ).style.display = "block");
            }),
            document.querySelector('[type="radio"]:checked') &&
              (r.answer = document.querySelector(
                '[type="radio"]:checked'
              ).value),
            !n)
          )
            return !1;
          p.attr("disabled", !0),
            $.ajax({ url: o.attr("action"), method: "POST", data: r })
              .done(function () {
                let action = o.attr("action") || "";
                if (action.indexOf("/cooperation") !== -1) {
                  trackGoal("cooperation_form_submit");
                } else if (action.indexOf("/unsubscribe") !== -1) {
                  trackGoal("unsubscribe_form_submit");
                }
                a(e).then(function () {
                  p.attr("disabled", !1);
                });
              })
              .fail(function (e) {
                if (
                  (p.attr("disabled", !1),
                  void 0 === e.responseJSON ||
                    void 0 === e.responseJSON.message)
                ) {
                  console.error("Invalid data", e);
                  return;
                }
                let t = JSON.parse(e.responseJSON.message);
                for (let n in t) {
                  let r = s[n];
                  void 0 !== r && l(r, t[n]);
                }
                o.find(".js_smart-captcha").yandexSmartCaptcha("reset");
              });
        }),
      e
        .fadeIn(300)
        .promise()
        .then(function () {
          e.find(".js_smart-captcha").yandexSmartCaptcha("render");
        })
    );
  }
  function a(e) {
    return e
      .fadeOut(300)
      .promise()
      .then(function () {
        n.removeClass(r),
          u(e.find("form")),
          e.off(".popup"),
          e.find(".js_smart-captcha").yandexSmartCaptcha("destroy", !0);
      });
  }
  function u(e) {
    e.find(".tpl-form-popup-label").removeClass("tpl__is-error");
  }
  function l(e, t) {
    let o = e.closest(".tpl-form-popup-label");
    o.addClass("tpl__is-error"), o.find(".tpl-form-popup-error").text(t);
  }
  $(".tpl__js-popup-form-uniq input[type=tel]").inputmask({
    mask: "+7 (999) 999-9999",
    clearIncomplete: !1,
    showMaskOnHover: !1,
  }),
    $(".tpl__js-popup-form-uniq a.tpl-checkbox__label-link").fancybox({
      type: "html",
      width: "900",
      height: "1000",
      "auto-focus": !1,
    }),
    e.on("click.popup", function (e) {
      e.preventDefault(), s(t);
    }),
    o.on("click.popup", function (e) {
      e.preventDefault(), s(p);
    }),
    document.querySelectorAll("input[type=radio]").forEach(function (e) {
      e.addEventListener("change", function () {
        "Свой ответ" == this.value
          ? ((document.getElementById("your-answer-unsubscribe").style.display =
              "block"),
            document
              .getElementById("your-answer-unsubscribe")
              .classList.add("tpl__js-form-popup-required"))
          : ((document.getElementById("your-answer-unsubscribe").style.display =
              "none"),
            (document.getElementById("your-answer-field").value = ""),
            document
              .getElementById("your-answer-unsubscribe")
              .classList.remove("tpl__js-form-popup-required")),
          (document.getElementById(
            "error-answer-popup-unsubscribe"
          ).style.display = "none");
      });
    });
});
